<template>
    <div class="component experience-principles-nav" :class="{ 'is-visible': showNav }" id="experience-principles-nav">
        <nav class="tab-nav">
            <a
                href="#ep-fast-and-easy"
                class="section-link"
                :class="{ active: activeSectionName === 'ep-fast-and-easy' }"
            >
                <div class="section-number">
                    01
                </div>
                <div class="section-title">
                    Achieve Things Fast and Easy
                </div>
            </a>
            <a
                href="#ep-secure-and-appreciated"
                class="section-link"
                :class="{ active: activeSectionName === 'ep-secure-and-appreciated' }"
            >
                <div class="section-number">
                    02
                </div>
                <div class="section-title">
                    Feel Secure and Appreciated
                </div>
            </a>
            <a
                href="#ep-joy-and-togetherness"
                class="section-link"
                :class="{ active: activeSectionName === 'ep-joy-and-togetherness' }"
            >
                <div class="section-number">
                    03
                </div>
                <div class="section-title">
                    Gain Joy and Togetherness
                </div>
            </a>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'ExperiencePrinciplesNav',
        computed: {
            showNav() {
                return this.$store.getters.showEpNavBar;
            },
            activeSectionName() {
                return this.$store.getters.activeSectionName;
            },
        },
    };
</script>

<style scoped lang="scss">
    .component {
        pointer-events: none;
        opacity: 0;
        position: fixed;
        width: 100%;
        bottom: 0px;
        z-index: 1;
        transition: opacity 0.5s;

        @media (max-width: breakpoint('large')), (max-height: 750px) {
            display: none;
        }

        &:before {
            content: '';
            position: absolute;
            top: 0vh;
            height: 10vh;
            width: 100%;
            pointer-events: none;
            transition: top 0.5s;
        }

        &.is-visible {
            pointer-events: all;
            opacity: 1;

            &:before {
                top: -10vh;
            }

            a {
                opacity: 1;
                transform: translateY(0px);
            }
        }
    }

    .tab-nav {
        @include flex($justify-content: center);
        text-align: center;
        margin-bottom: spacing(10);

        a {
            opacity: 0;
            display: block;
            text-decoration: none;
            transform: translateY(10px);
            transition: opacity 0.5s, transform 0.5s, color 0.3s;

            &:nth-of-type(1) {
                transition-delay: 0.2s;
            }

            &:nth-of-type(2) {
                border-left: 1px solid #000;
                border-right: 1px solid #000;
                padding: 0 spacing(12);
                margin: 0 spacing(12);
                transition-delay: 0.4s;
            }

            &:nth-of-type(3) {
                transition-delay: 0.6s;
            }

            &.active {
                color: color('magenta');
            }

            * {
                pointer-events: none;
            }
        }

        .section-number {
            font-size: 21px;
            font-weight: font-weight('thin');
            margin-bottom: spacing(2);
        }

        .section-title {
            font-weight: font-weight('medium');
        }
    }
</style>
